import { render, staticRenderFns } from "./verificationMsg.vue?vue&type=template&id=d9f7e73c&scoped=true"
import script from "./verificationMsg.vue?vue&type=script&lang=js"
export * from "./verificationMsg.vue?vue&type=script&lang=js"
import style0 from "./verificationMsg.less?vue&type=style&index=0&id=d9f7e73c&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f7e73c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9f7e73c')) {
      api.createRecord('d9f7e73c', component.options)
    } else {
      api.reload('d9f7e73c', component.options)
    }
    module.hot.accept("./verificationMsg.vue?vue&type=template&id=d9f7e73c&scoped=true", function () {
      api.rerender('d9f7e73c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/VerificationMsg/verificationMsg.vue"
export default component.exports